import wrappedFetch from './base';

const params = {
  method: 'POST',
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
};


export const getStrykexKycStatus = () => {
  const uri = '/getStrykexKycStatus';

  return wrappedFetch(uri, params)
    .then((response) => response.json())
    .then((result) => {
      return result;
    });
};

export const getUserFromRuns = (runId) => {
  const uri = `/runs/${runId}/user_details`;
  return wrappedFetch(uri).then((response) => response.json())
};
